export const HTML_NON_BREAKING_SPACE = '&nbsp;';
export const FIELD_DEFAULT_VALUE = 'None';
